import React, {Component} from 'react';
import {connect} from 'react-redux';
import ChatUserSearchItem from "./ChatUserSearchItem";
import cloneDeep from 'lodash/cloneDeep';
import stateLinker from '../../utils/stateLinker';
import axios from 'axios';
import { history } from '../../history_mobx';
import { observer, inject } from "mobx-react";
import { makeObservable, observable, reaction, toJS } from "mobx";
import { input } from "../../utils/linker";
import { withRouter } from 'react-router-dom';

//actions
import appendChatOpenedWindows from '../../actions/chat/appendChatOpenedWindows';
import setChatState from '../../actions/chat/setChatState';
import setGlobalErrors from '../../actions/setGlobalErrors';
import UserBox from "../Helpers/User/UserBox";


class ChatGroupCreator extends Component {
  user_search='';
  users={items:[],inited:false,fetching:false};
  selected_users=[];
  selected=undefined;
  chat_name='';
  btn_class='';

  constructor(props)
  {
    super(props);
    makeObservable(this,{
      user_search: observable,
      users: observable,
      selected_users: observable,
      selected: observable,
      chat_name: observable,
      btn_class: observable,
    });

    this.state={
      user_search:'',
      users:{
        items:[],
        inited:false,
        fetching:false,
      },
      selected_users:[],
      selected: undefined,
      chat_name:'',
      btn_class:''
    }

    this.reactions=[];
    this.reactions.push(reaction(()=>{ return this.user_search; },(str)=>{
      if(str) {
        this.searchUsers();
      } else {
        //scroll?
      }
    }));

  }
  /*
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.state.user_search && this.state.user_search != prevState.user_search) {
      this.searchUsers();
    } else {
      if (!this._itemRef && this._wrapRef) {
        this._wrapRef.scrollTop = 0;
      }
      if (this._itemRef && this._wrapRef) {
        //scroll controll
        let wrapRect = this._wrapRef.getBoundingClientRect();
        let itemRect = this._itemRef.getBoundingClientRect();

        const summUp=itemRect.top-wrapRect.top;
        const summDown=itemRect.top+itemRect.height-wrapRect.top-wrapRect.height;

        if(summDown>0) {
          this._wrapRef.scrollTop += summDown;// * (-1);
        }
        if(summUp<0) {
          this._wrapRef.scrollTop += summUp;// * (-1);
        }
      }

    }
  }
  */
  searchUsers() {
    this.users.fetching=true;
    axios.get(`/api/user?filter[~nick]=%25${this.user_search}%25&filter[!%3Did]=${this.props.meStore.me.data.id}`).then((data) => {
      this.users={
        fetching: false,
        inited:true,
        items:data.data.answer.items
      };
      this.selected=undefined;
    });
  }
  renderUserSearch() {
    if (this.users.inited) {
      if (this.users.items && this.users.items.length) {
        return this.users.items.map((user,index) => {
          return (
            <div key={user.id}
                 ref={(ref)=>{  if(index===this.selected){ this._itemRef=ref; } }}
                 className={`${index===this.selected?'bg-pc1 w1':''}`}
                 onMouseOver={()=>{ this.selected=index; }}
                 onClick={()=>{ this.selected=index; }}
            >
              <div className="up12 splice" style={{height:50}}>
                <div className="cell s-shrink pleft10 s-middle">
                  <UserBox
                    avatar={user.avatar}
                    nick={user.nick}
                    size={40}
                  />
                </div>
                <div className="cell s-auto s-middle">
                  <div className="pleft10">
                    {user.nick}
                  </div>
                </div>
              </div>

            </div>
          )
        });
      } else {
        return (
          <div className="hpadd5 vpadd10">
            {this.props.translateStore.t.evaPrivateChat.v2_chat_user_not_found}
          </div>
        )
      }
    }
    return null;
  }
  componentDidMount() {
    if(this.props.selectedChange) {
      this.props.selectedChange([]);
    }
  }

  keyDown(e) {
    const keyId = e.which;
    console.log('keyId', keyId);
    //up 38, down 40, enter 13
    let setSelected = 'not_set';
    switch (keyId) {
      case 38: //up
        e.preventDefault();
        if (typeof this.selected === 'undefined') {
          setSelected = this.users.items.length - 1;
        } else {
          setSelected = this.selected - 1;
        }
        break;
      case 40: //down
        e.preventDefault();
        if (typeof this.selected === 'undefined') {
          setSelected = 0;
        } else {
          setSelected = this.selected + 1;
        }
        break;
      case 13: //enter
        e.preventDefault();
        if (typeof this.selected !== 'undefined') {
          this.selectMe(this.selected);
        }
        break;
      case 8: //backspace?

        break;
    }
    if (setSelected !== 'not_set') {
      if (setSelected > this.users.items.length - 1) {
        setSelected = this.users.items.length - 1;
      }
      if (setSelected < 0) {
        setSelected = 0;
      }
      this.selected=setSelected;
    }
  }
  removeMe(index) {
    index=parseInt(index);
    // let selected=cloneDeep(this.selected_users);
    console.log('remove me',index,this.selected_users[index]);
    if(this.selected_users[index]) {
      this.selected_users.splice(index,1);
      if(this.props.selectedChange) {
        this.props.selectedChange(this.selected_users);
      }
      // this.selected_users=selected;
    }
  }
  selectMe(index) {
    if(this.users.items[index]) {
      const cur=this.users.items[index];
      const found=this.selected_users.find((item)=>{ return item.id===cur.id; });
      if(!found) {
        this.selected_users.push(toJS(cur));
      }
      if(this.props.selectedChange) {
        this.props.selectedChange(this.selected_users);
      }
    }
  }
  dialogCreate() {
    if(!this.btn_class) {
      this.btn_class='btnLoading';
      const users = this.selected_users.map((item) => {
        return item.nick;
      });
      axios.post('/api/privatechat/create_chat', {users: users, name: this.chat_name}).then((data) => {
        this.setState({ btn_class: '' });
        this.btn_class='';
        if(data.data.errors) {
          this.props.appStateStore.pushGlobalErrors(data.data.errors);
        } else {
          if (data.data.answer) {
            if (this.props.standalone) {
              this.props.done();
              this.props.router.push(`/chat/${data.data.answer}`);
            } else {
              this.props.done();
              this.props.chatStore.appendOpenedWindow(data.data.answer);
              // this.props.chatStore.main_window
              // this.props.setChatState({win: null});
            }
          }
        }
      });
    }
  }
  addUsersClick() {
    if(!this.btn_class) {
      this.btn_class='btnLoading';
      const nicks=this.selected_users.map((user)=>{
        return user.nick;
      });
      axios.post(`/api/privatechat/${this.props.chat_id}/add`,{ nicks:nicks }).then((data)=>{
        this.btn_class='';
        if(data.data.errors) {
          this.props.appStateStore.pushGlobalErrors(data.data.errors);
        }
        if(data.data.answer) {
          this.props.done();
        }
      });
    }
  }
  renderSelected() {
    if(this.selected_users.length>0) {
      const items = this.selected_users.map((item,index) => {
        return (
          <span className="bg-sc1-op90 dib hpadd5 rad3 fs12 mbottom5 mright5 vpadd5 wsnw" key={item.id}>
            {item.nick}
            <i className="mdi mdi-close pointer" onClick={()=>{ this.removeMe(index); }}></i>
          </span>
        )
      });
      return (
        <div className="pbottom10 mbottom10 solid1-bottom ptop10 bo-w2">
          <div className="pleft5">
            {items}
          </div>
          {this.props.mode == 'add'?(
            <div className="dn">
              {this.selected_users.length > 0 ? (
                <div className="tar">
                  <span className={`btn2 mright10 ${this.btn_class}`} onClick={()=>{ this.props.done(); }}><span>{this.props.translateStore.t.evaPrivateChat.cancel}</span></span>
                  <span className={`btn1 ${this.btn_class}`} onClick={()=>{ this.addUsersClick(); }}><span>Добавить</span></span>
                </div>
              ) : null}
            </div>
            ):(
            <div className="hpadd5">
              {this.selected_users.length == 1 ? (
                <div className="tar">
                  <span className={`btn1 ${this.btn_class}`} onClick={()=>{ this.dialogCreate(); }}><span>{this.props.translateStore.t.evaPrivateChat.v2_chat_to_dialog}</span></span>
                </div>
              ) : null}
              {this.selected_users.length > 1 ? (
                <div className="hpadd5">
                  <div className="up12 splice">
                    <div className="cell s-auto s-middle pright10 noBorder">
                      <input type="text" className="w100" placeholder={this.props.translateStore.t.evaPrivateChat.v2_chat_chat_name} {...input(this,'chat_name')} />
                    </div>
                    <div className="cell s-shrink tar">
                      <span className={`btn1 ${this.btn_class}`} onClick={()=>{ this.dialogCreate(); }}><span>{this.props.translateStore.t.evaPrivateChat.v2_chat_create_btn}</span></span>
                    </div>

                  </div>
                </div>
              ) : null}
            </div>
          )}
        </div>
      );
    }
  }
  render() {
    return (
      <div className="h100 ">
        <div className="up12-v s-v-nowrap splice h100">
          <div className="v-cell s-v-shrink">
            <div>
              {this.renderSelected()}
            </div>
            <div className="noBorder solid1-bottom bo-w2">
              <input
                autoFocus={true}
                {...input(this,'user_search')}
                type="text"
                className=" w100"
                placeholder={this.props.translateStore.t.evaPrivateChat.v2_chat_user_nick_search}
                onKeyDown={(e)=>{ this.keyDown(e); }}
                ref={(ref)=>{ this._inputRef=ref; }}
              />
            </div>
          </div>
          <div className="v-cell s-v-auto">
            <div ref={(ref)=>{ this._wrapRef=ref; }} className="bg-w1 ofa bg-w1 h100">
              {this.renderUserSearch()}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    me:state.me,
    t: state.translate,
  }
}

// export default connect(mapStateToProps,{ setChatState, appendChatOpenedWindows,setGlobalErrors }, null, { withRef: true })(ChatGroupCreator);
export default withRouter(inject("meStore","translateStore","chatStore","appStateStore","router")(observer(ChatGroupCreator)));